<template>
  <div>
    <el-dialog :title="title" :visible="localVisible" width="70%" @close="onClose">
      <el-form label-width="110px" :inline="true" size="mini">
            <el-form-item >
          <el-input 
  v-model="keywords" 
  clearable 
  placeholder="轮毂名称"
></el-input>
            </el-form-item>
           <el-form-item>
            <el-button @click="chooseItem">查询</el-button>
            </el-form-item>
      </el-form>
      <div>
        <el-table
          ref="multipleTable"
          :data="mList"
          height="300"
          stripe
          border
          size="mini"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
        >
           <el-table-column label="" width="50" align="center">
            <template slot-scope="scope">
              <el-radio v-model="curShop" :label="scope.row" @input="clickChange(scope.row,scope.$index)">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            label="轮毂名称"
            width="120"
            prop="goods_name"
            :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
                  label="中心孔"
                  width="100"
                  prop="center_bore"
                  :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
                  label="ET"
                  width="100"
                  prop="et"
                  :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
                  label="图片"
                  width="100"
                  :show-overflow-tooltip='true'
          >
            <template slot-scope="scope">
            <span>
                <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.goods_img"
                ></el-image>
            </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:10px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>s
        <el-row>
          <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
            <el-button size="mini" @click="close">取消</el-button>
            <el-button  size="mini" type="primary" @click="ok">确定</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
  name:'eShopList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: "",
    },
    closeForm: Function,
  },
  data(){
    return {
      localVisible:false,
      index:'',
      curShop:'',
      id:'',
      name:'',
      keywords:'',
      fileList:[],
      mList:[],
      pageNum:1,
      pageSize:10,
      total:0,
      item:{}
    }
  },
  mounted() {
    // 弹窗组件不建议在 mounted 直接请求，会浪费接口
    // this.DataList();
  },
  methods:{
    // 设置每页条数
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    onClose(){
      this.$emit('update:visible',false)
      this.closeForm();
      // 关闭弹窗清空搜索和选中项
      this.keywords = ''
      this.curShop = ''
    },
    close(){
      this.$emit('update:visible',false)
      this.closeForm();
      this.keywords = ''
      this.curShop = ''
    },
    ok(){
      if(!this.id){
        this.$message.warning('请选择一条数据')
        return
      }
      this.$emit('eventChoose',this.id,this.name,this.item);
      this.$emit('update:visible',false)
      this.closeForm();
      // 确定后清空
      this.keywords = ''
      this.curShop = ''
    },
    DataList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        shop_id: sessionStorage.getItem('shop_id'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      // 关键：有搜索关键词就带上
      if(this.keywords){
        param.keywords = this.keywords.trim();
      }
      this.$axios.findByShopGoodsListP(param).then(res=>{
        if(res.code == 200){
          this.mList = res.data.data
          this.total = res.data.total
        }
      }).catch(error=>{
        console.log(error);
      })
    },
    clickChange(row,index){
      this.index = index;
      this.id = row.goods_id;
      this.name = row.goods_name;
      this.item = row; // 直接赋值当前行更稳妥
      console.log('选中数据：',row);
    },
    // ✅ 已完善：查询按钮功能
    chooseItem(){
      // 重置到第一页，再查询
      this.pageNum = 1;
      this.DataList();
    },
    handleBeforeUpload(){},
    uploadSuccess(){},
    uploadFile(){},
  },
  watch: {
    visible(val) {
      this.localVisible = val;
      if (val) {
        // 弹窗打开时再请求数据，优化性能
        this.DataList();
      }else{
        // 关闭清空
        this.keywords = ''
        this.curShop = ''
      }
    },
  },
}
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
